let inViewPortChecks = document.querySelectorAll('*[data-in-viewport]')
    for (let target of inViewPortChecks) {

        let visiblePercentActive = 40;

        if (target.dataset.visiblePercentActive) {
            visiblePercentActive = parseInt(target.dataset.visiblePercentActive);
        }
        const scrollListener = () => {
            closeNavScrollThrottle();
        };

        function startListening() {
            window.addEventListener('load', event => {
                isInViewport()
            });
            window.addEventListener('scroll', scrollListener);
        }

        function stopListening() {
            window.removeEventListener('scroll', scrollListener);
        }

        startListening();

        function isInViewport() {
            const isElementXPercentInViewport = function(element, percentVisible) {
                let
                    rect = element.getBoundingClientRect(),
                    windowHeight = (window.innerHeight || document.documentElement.clientHeight);

                return !(
                    Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100)) < percentVisible ||
                    Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
                )
            };

            if (isElementXPercentInViewport(target, visiblePercentActive)) {
                setTimeout( function() {
                    target.dataset.inViewport = 'true';
                }, 150);
                if (target.dataset.animationRuntime) {
                    let runtime = parseInt(target.dataset.animationRuntime);
                    setTimeout( function() {
                        target.removeAttribute('data-in-viewport');
                    }, runtime);
                }
                stopListening();
            }
        }
        const closeNavScrollThrottle = _throttle(isInViewport, 50, { leading: true, trailing: true });
    }

